import { render, staticRenderFns } from "./ConsultaReclamacionesForm.vue?vue&type=template&id=166adccc&scoped=true"
import script from "./ConsultaReclamacionesForm.vue?vue&type=script&lang=ts"
export * from "./ConsultaReclamacionesForm.vue?vue&type=script&lang=ts"
import style0 from "./ConsultaReclamacionesForm.vue?vue&type=style&index=0&id=166adccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166adccc",
  null
  
)

export default component.exports